module.exports = __webpack_public_path__ + "img/image3.0f6aef5a.jpg";